import http from '../http-common';

class ODConnectorService {

    getLatestExePath = () => http.get('/od-connector/latest-exe-path');

    getIntegrationToken = () => http.get('/od-connector/integration-token');
}

export default new ODConnectorService();